import { ref } from "vue";

export const cdrPatientRefreshSignal = ref(0);

export function triggerPatientCdrRefresh(): void {
  cdrPatientRefreshSignal.value++;
}
